import { HashLink } from 'react-router-hash-link';
import { useMobileNavigation } from '@/state/MobileNavigationContext';
import { unauthenticatedItems } from '@/constants/navigation-items';
import Button from '@/components/elements/Button';
import { HamburgerToggle } from '@/components/HamburgerToggle';
import HeaderNavigation from '@/components/HeaderNavigation';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useAuthActions } from '@/hooks/useAuthActions';
import ContactButton from '@/components/ContactButton';

function LandingPageHeader() {
  const desktopBreakpoint = 920;
  const isMobile = useIsMobile(desktopBreakpoint);
  const { handleLogin } = useAuthActions();
  const { isOpen, setIsOpen } = useMobileNavigation();

  return (
    <header
      data-cy='page-header'
      className='bg-white h-[64px] desktopNav:h-[72px] fixed w-full z-40 top-0 start-0 border-b border-gray-200 flex items-center'
    >
      <div className='w-full relative desktopNav:container desktopNav:mx-auto px-4 flex flex-nowrap items-center justify-between'>
        <HashLink smooth to='/#' className='flex items-center space-x-3 rtl:space-x-reverse flex-shrink'>
          <img src='/logo-long.png' alt='Eklpix Research Logo' className='max-h-9 desktopNav:max-h-11' />
        </HashLink>

        <div className='flex desktopNav:w-auto'>
          <div className='ml-4 desktopNav:w-auto flex items-center justify-center gap-2'>
            <Button data-cy='login-button' variant='hollow' buttonText='Login' onClick={handleLogin} className='flex' />
            <ContactButton className='ml-1 [@media(max-width:540px)]:hidden' />
            <HamburgerToggle isOpen={isOpen} onToggle={() => setIsOpen(!isOpen)} className='desktopNav:hidden' />
          </div>
        </div>
      </div>

      <HeaderNavigation isMobile={isMobile} variant='top-middle' items={unauthenticatedItems} />
    </header>
  );
}

export default LandingPageHeader;
